import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import ReplyButton from '../ReplyButton'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import FooterPure from './FooterPure'

function Footer({
  feed,
  level,
  isModal,
  isInputVisible,
  renderReactionContainer,
  openPostModal,
  expandReplies,
  collapseReplies,
  collapseRepliesAll,
  visibleRepliesCount,
  showInputArea,
  hideInputArea,
  feedInFileModal
}) {
  const { t } = useTranslation()
  const [toggleInputArea, setToggleInputArea] = useState(true)
  return (
    <FooterPure
      isModal={isModal}
      level={level}
      totalResponseCount={feed.responses.length}
      moreCommentLabel={t('mixrHome.feeds.showMoreComments')}
      openPostModal={openPostModal}
      renderTotalResponseIcon={() => <Icon name='discussion' size='large24' />}
      renderReactionContainer={renderReactionContainer}
      renderReplyButton={
        level > 1
          ? feed?.responses?.length > 0
            ? () => (
                <ReplyButton
                  isExpanded={
                    isModal
                      ? visibleRepliesCount > 0
                      : isInputVisible || visibleRepliesCount > appConstantSettings.MIN_REPLIES_ON_FEED
                  }
                  count={feed.responses.length}
                  onClick={() => {
                    const expanded = !isInputVisible
                    if (expanded) {
                      const isShowMoreReplyVisible = document.getElementById(`showMoreReply${feed.id}`)
                      if (isShowMoreReplyVisible) {
                        expandReplies(feed.id, true)
                      } else {
                        expandReplies(feed.id)
                      }
                      showInputArea(false) //false parameter is to not open create feed modal because there are responses in feed.
                    } else {
                      if (isModal || feedInFileModal) {
                        collapseRepliesAll(feed.id)
                      } else {
                        collapseReplies()
                      }
                      hideInputArea()
                    }
                  }}
                />
              )
            : () => (
                <ReplyButton
                  count={0}
                  isExpanded={false}
                  onClick={() => {
                    setToggleInputArea(!toggleInputArea)
                    if (toggleInputArea) {
                      showInputArea()
                    } else {
                      hideInputArea()
                    }
                  }}
                />
              )
          : null
      }
    />
  )
}

export default Footer
